import styled from "styled-components";

export const StakeLocked = styled.div`
  .warning {
    width: 100%;
    font-size: 1.2rem;
    margin: 0px;
    margin-top: 1rem;
    color: ${(props) => props.theme.palette.common.text.secondary};
  }
  .horizontalLine {
    background-color: ${(props) => props.theme.palette.common.background};
    width: 100%;
    margin: 0px;
    margin-top: 10px;
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  margin: 20px auto;
`;

export const AmountText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 1rem auto 0 auto;
  > p {
    color: ${({ theme }) => theme.palette.common.text.secondary};
    font-size: 13px;

    margin: 0px;
    display: flex;
    width: 100%;
  }
`;

export const Reward = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;

  p {
    color: ${({ theme }) => theme.palette.common.text.secondary};
    font-size: 13px;
    margin: 0;
  }
  input[type="range"] {
    overflow: hidden;
  }

  input {
    color: ${({ theme }) => theme.palette.card.text.primary};
  }
`;

export const AmountDiv = styled.div`
  justify-content: center;
  display: flex;
  p {
    color: ${({ theme }) => theme.palette.common.text.secondary};
    font-size: 13px;
    margin: 0;
  }
`;
export const InputDiv = styled.div`
  background: #fcfcfc 0% 0% no-repeat padding-box;
  opacity: 1;
  display: flex;
  border: none;
  padding: 12px;
  width: 100%;
  :focus-visible {
  }
`;

export const TextAlign = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.palette.common.text.secondary};
  text-align: end;
  display: block !important;
  align-items: center;
  height: 20px;
  > p {
    color: ${(props) => props.theme.palette.common.text.secondary};
    font-size: 13px;
    width: 100%;
  }
`;

export const InputCurrency = styled.input`
  border: none;
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  outline: none !important;
  background-color: ${(props) => props.theme.palette.card.background.primary};
`;
export const Max = styled.button`
  color: ${(props) => props.theme.palette.common.text.primary};
  font-size: 16px;
  display: contents;
  font-weight: 600;
  border: none;
  margin: 0px;

  width: 100%;
`;

export const InputContainer = styled.div`
  position: relative;
  width: 100%;

  #slider {
    -webkit-appearance: none;
    width: 100%;
    height: 7px;
    outline: none;
    border-radius: 3px;
  }
  #slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 18px;
    height: 18px;
    cursor: pointer;
    z-index: 3;
    position: relative;
    left: ${({ $max, $value }) => ($value / $max) * 100 + "%"};
    transform: translateX(-50%);
  }
  #slider::-moz-range-thumb {
    -webkit-appearance: none;
    width: 18px;
    height: 18px;
    cursor: pointer;
    z-index: 3;
    position: relative;
    left: ${({ $max, $value }) => ($value / $max) * 100 + "%"};
    transform: translateX(-50%);
  }
  #selectBtn {
    height: 18px;
    width: 18px;
    border-radius: 50%;
    position: absolute;
    bottom: 0px;
    background-color: ${({ theme }) => theme.palette.card.text.primary};
    z-index: 2;
    left: ${({ $max, $value }) => ($value / $max) * 100 + "%"};
    transform: translateX(-50%);
  }
  #progressBar {
    width: ${({ $max, $value }) => ($value / $max) * 100 + "%"};
    height: 7px;
    background-color: ${({ theme }) => theme.palette.card.text.primary};
    border-radius: 3px;
    position: absolute;
    top: 3.5px;
    left: 0;
  }
`;
